export default __webpack_public_path__ + "static/media/bg.5835edc2.webp";